import { render } from "./PatientList.vue?vue&type=template&id=f85853e0"
import script from "./PatientList.vue?vue&type=script&lang=js"
export * from "./PatientList.vue?vue&type=script&lang=js"

import "./PatientList.vue?vue&type=style&index=0&id=f85853e0&lang=scss"

import exportComponent from "/usr/src/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__